import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartType } from 'services/types/ui';
import { PeriodEnum } from 'services/types/PeriodEnum';
import { SelectOptionsValues } from 'features/Charts/LineEnergyProduction/types'; // Import SelectOptionsValues
import { ViewType } from 'features/EnergyPies/GroupedData/types'; // Import ViewType

interface UiState {
  activeTab: ViewType; // Changed type from number to ViewType
  chartType: ChartType;
  viewMode: PeriodEnum;
  periodIndex: number;
}

const initialState: UiState = {
  activeTab: 'costs-data', // Updated default to match ViewType
  chartType: SelectOptionsValues.EnergyDemandVsProduction, // Updated default chartType
  viewMode: PeriodEnum.MONTTH,
  periodIndex: 0,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<ViewType>) {
      // Updated PayloadAction type
      state.activeTab = action.payload;
    },
    setChartType(state, action: PayloadAction<ChartType>) {
      state.chartType = action.payload;
    },
    setViewMode(state, action: PayloadAction<PeriodEnum>) {
      state.viewMode = action.payload;
      state.periodIndex = 0; // Reset period index when view mode changes
    },
    setPeriodIndex(state, action: PayloadAction<number>) {
      state.periodIndex = action.payload;
    },
    setUiStateFromQueryParams(state, action: PayloadAction<Partial<UiState>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setActiveTab, setChartType, setViewMode, setPeriodIndex, setUiStateFromQueryParams } = uiSlice.actions;
